import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";

const AgentPerLine = ({ startDate, endDate, token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/QAInbound/inboundReports/AgentPerLine?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setData({ ...response.data, data: response.data.data || [] });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate, token]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data || data.data.length === 0) return <h3>No Data Available</h3>;

  const columns = [
    {
      field: "queue_id",
      headerName: "Queue",
      flex: 1,
    },
    {
      field: "clientservices_agent",
      headerName: "Client Services Agent",
      flex: 1,
    },
    {
      field: "calls",
      headerName: "Total Calls",
      type: "number",
      flex: 1,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "twominutes",
      headerName: "> 2 Minutes",
      type: "number",
      flex: 1,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "evaluations",
      headerName: "Evaluations",
      type: "number",
      flex: 1,
      align: "right",
      headerAlign: "right",
    },
    // percentage evaluations / twominutes
    {
      field: "evaluationsPercentage",
      headerName: "Evaluations Percentage",
      type: "number",
      flex: 1,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) => {
        const evaluations = params.row.evaluations || 0;
        const twominutes = params.row.twominutes || 1; // Avoid division by zero
        return ((evaluations / twominutes) * 100).toFixed(2);
      },
    },
    {
      field: "incomplete",
      headerName: "Incomplete",
      type: "number",
      flex: 1,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "failed",
      headerName: "Failed",
      type: "number",
      flex: 1,
      align: "right",
      headerAlign: "right",
    },
    {
      field: "complete",
      headerName: "Complete",
      type: "number",
      flex: 1,
      align: "right",
      headerAlign: "right",
    },
    // percentage complete / evaluations
    {
      field: "completePercentage",
      headerName: "Complete Percentage",
      type: "number",
      flex: 1,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) => {
        const complete = params.row.complete || 0;
        const evaluations = params.row.evaluations || 1; // Avoid division by zero
        return ((complete / evaluations) * 100).toFixed(2);
      },
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ height: 600, width: "100%", mt: 2 }}>
        <DataGridPremium
          autoHeight
          rows={data.data}
          columns={columns}
          getRowId={(row) => `${row.queue_id}-${row.clientservices_agent}`}
          slots={{ toolbar: GridToolbar }}
          pagination
          pageSize={pageSize}
          onPageSizeChange={(newSize) => setPageSize(newSize)}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          pageSizeOptions={[5, 10, 15, 20]}
        />
      </Box>
    </Box>
  );
};

export default AgentPerLine;
